"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowProvider = exports.useDocument = exports.useWindow = exports.WindowContext = void 0;
var WindowProvider_1 = require("./WindowProvider");
Object.defineProperty(exports, "WindowContext", { enumerable: true, get: function () { return WindowProvider_1.WindowContext; } });
Object.defineProperty(exports, "useWindow", { enumerable: true, get: function () { return WindowProvider_1.useWindow; } });
Object.defineProperty(exports, "useDocument", { enumerable: true, get: function () { return WindowProvider_1.useDocument; } });
Object.defineProperty(exports, "WindowProvider", { enumerable: true, get: function () { return WindowProvider_1.WindowProvider; } });
require("./version");
//# sourceMappingURL=index.js.map